import { Empty } from 'antd';

import { SubTitle, SubTitleWrapper } from '@page/consumers/consumers.page-style';
import { ConsumerButtonTitle } from '@page/consumers/new-consumer/new-consumer.style';
import { sequencesTableOptions } from '@page/sequences/sequences.options';
import { PageTitle, PageWrapper } from '@style/pages/page.style';

import SequencesIcon from '@asset/sequences.icon.svg?react';
import { Button } from '@atom/button/button';
import { ButtonTypeEnum } from '@atom/button/button.enum';
import { Table } from '@atom/table/table';
import { RouteEnum } from '@enum/route.enum';
import { ColorEnum } from '@enum/style/color.enum';

export const SequencesPage = () => {
  return (
    <PageWrapper>
      <PageTitle>Sequences</PageTitle>
      <SubTitleWrapper>
        <SubTitle />
        <Button
          href={RouteEnum.NewSequences.path}
          icon={<SequencesIcon fill={ColorEnum.Black100} height={24} width={24} />}
          size='small'
          type={ButtonTypeEnum.Primary}
          block
          ghost
        >
          <ConsumerButtonTitle>Add Sequences</ConsumerButtonTitle>
        </Button>
      </SubTitleWrapper>
      <Table
        columns={sequencesTableOptions}
        dataSource={[]}
        pagination={false}
        rowKey='id'
        // loading={isLoading}
        locale={{
          emptyText: <Empty description='You dont have any added sequences' image={Empty.PRESENTED_IMAGE_SIMPLE} />,
        }}
      />
    </PageWrapper>
  );
};
